export const getInvalidUrlMessage = (val: string, hasYoutubeMessage?: boolean) => {
  // not a valid relative route
  return !val
    ? 'Required'
    : !val?.startsWith('http')
    ? 'Must start with http'
    : val?.indexOf(' ') >= 0
    ? 'Must not contain white space'
    : hasYoutubeMessage && !val?.includes('youtube')
    ? 'Must be a youtube url'
    : '';
};

export const isValidUrl = (val: string) => {
  // not a valid relative route
  return !val?.startsWith('http') ||
    // required field for a sub route link
    !val ||
    // can't contain white space
    val?.indexOf(' ') >= 0 ||
    // not a youtube link
    !val?.includes('youtube')
    ? true
    : false;
};
